import React, { useEffect, useRef } from "react";
import { Item, ItemText } from "./AdPanelDropdown.styles";
import { SelectedItemProps } from "@bale/ui";
import { useTheme } from "@emotion/react";

type Formatter<T> = {
  formatter?: (item: T) => string;
};

const SelectedItem = <T,>(props: SelectedItemProps<T> & Formatter<T>) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const theme = useTheme();

  const InputProps = {
    ...props.getInputProps(),
    placeholder: props.placeholderMessage,
  };
  useEffect(() => {
    if (props.isOpen === true) {
      props.setInputValue("");
      // inputRef.current?.querySelector("input")!.focus(); // disabling focus
    }
  }, [props.isOpen]);
  return (
    <Item
      isPreview={true}
      isPlaceholder={!props.isOpen && props.selectedItem == null}
      ref={inputRef}
      theme={theme}
    >
      {!props.isOpen && props.selectedItem != null && (
        <>
          <ItemText
            {...InputProps as any}
            isPreview={false}
            data-testid="hour-selected-item"
          >
            {props.formatter
              ? props.formatter(props.selectedItem)
              : props.selectedItem}
          </ItemText>
        </>
      )}
      {!props.isOpen && props.selectedItem == null && (
        <span {...InputProps as any}>{props.placeholderMessage}</span>
      )}
    </Item>
  );
};

export const formatSelectedItem = <T,>(
  props: SelectedItemProps<T>,
  formatter: (item: T) => string
) => {
  return <SelectedItem {...props} formatter={formatter}></SelectedItem>;
};
